import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import {
  Firestore,
  doc,
  DocumentData,
  DocumentReference,
  docData,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { AuthFirebaseService } from '@core/services/auth-firebase/auth-firebase.service';
import { UserStateService } from '@core/services/user-state/user-state.service';
import { LanguageService } from '@shared/services/language/language.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        Toast
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit { 
  title: string = 'backoffice';

  authFirebaseService: AuthFirebaseService = inject(AuthFirebaseService);
  userStateService: UserStateService = inject(UserStateService);
  router: Router = inject(Router);
  firestore: Firestore = inject(Firestore);
  languageService: LanguageService = inject(LanguageService);
  
  readonly GLOBAL_FEATURE_ID: string = 'excuela-global-feature';
  readonly GLOBAL_FEATURE_COLLECTION: string = 'subdomains';
  readonly MAINTENANCE_MODE_ROUTE: string = '/maintenance';

  
  collectionRef: DocumentReference<DocumentData> = doc(this.firestore, this.GLOBAL_FEATURE_COLLECTION, this.GLOBAL_FEATURE_ID);
  documentData$: Observable<any | undefined> = docData(this.collectionRef);


  ngOnInit(): void {
    // Inicializar idioma (carga desde localStorage o usa español por defecto)
    this.languageService.initializeLanguage();

    this.documentData$.subscribe((data) => {
      if (data?.featureFlags?.boMaintenanceMode) this.handleDocumentData();
      
      if (this.router.url === this.MAINTENANCE_MODE_ROUTE) this.router.navigate(['/login']);

    });
  }

  private handleDocumentData(): void {

    this.authFirebaseService.logout().subscribe({
      next: () => {
        this.userStateService.clearUserInfo();
        this.router.navigate([this.MAINTENANCE_MODE_ROUTE]);
      },
      error: () => {
        this.userStateService.clearUserInfo();
        this.router.navigate([this.MAINTENANCE_MODE_ROUTE]);
      },
    });
  }
}
